import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SvgLoaderService {
  private svgCache = new Map<string, Observable<SafeHtml>>();

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) {}

  getInlineSvg(path: string): Observable<SafeHtml> {
    if (this.svgCache.has(path)) {
      return this.svgCache.get(path) as Observable<SafeHtml>;
    }

    const svg$ = this.http.get(path, { responseType: 'text' }).pipe(
      map((svgContent) => {
        return this.sanitizer.bypassSecurityTrustHtml(svgContent);
      }),
    );

    this.svgCache.set(path, svg$);
    return svg$;
  }
}
